export enum AppConstants {
  APP_INITED = 'APP_INITED',
  APP_HIDE_NOTIFICATION = 'APP_HIDE_NOTIFICATION',
}
